import { Component, HostListener, OnInit } from '@angular/core';
import { AuthorizeService } from 'src/app/services/authorize/authorize.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { CustomerService } from 'src/app/services/customer/customer.service';
import { CustomerDashboardModel, CustomerProfileModel } from 'src/app/models/customer/customerDashboard.model';
import { ToastrService } from 'ngx-toastr';
import { AddressService } from 'src/app/services/address/address.service';

@Component({
  selector: 'app-customer-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})


export class CustomerProfileComponent implements OnInit {
    isLoading: boolean = false;
    customerForm!: FormGroup;
    innerWidth: number | undefined;
    isScreenSmall: boolean = true;
    custId?: number;
    customerDashboard: Observable<CustomerDashboardModel> [] | undefined;
    submitted: boolean = false;
    customer: Observable<CustomerProfileModel> | undefined;
    addressStates$: any;
    addressCountries$: any;
    showEditForm: boolean = false;

@HostListener('window:resize', ['$event'])
onResize(event: any) {
  this.innerWidth = window.innerWidth;
  if (this.innerWidth < 770) { this.isScreenSmall = true; } else this.isScreenSmall = false;
}

  constructor(
    private _authorizeService: AuthorizeService,
    private _customerService: CustomerService,
    private _addressService: AddressService,
    private formBuilder: FormBuilder,
    private toastService: ToastrService) {
        this._authorizeService.user$.subscribe(user => {
            this.custId = user?.customerId;
          });

          this.initializeFormSelects();
          this.initializeForms();
          this.allPhoneValidate();
  }

    ngOnInit() {
      this.customer = this._customerService.getCustomerProfile$(this.custId!).pipe(tap((cust: { [key: string]: any; }) => this.customerForm.patchValue(cust)));
    }

    initializeFormSelects() {
      this.addressStates$ = this._addressService.getAddrStates$;
      this.addressCountries$ = this._addressService.getAddrCountries$;
    }

  initializeForms() {
    this.customerForm = this.formBuilder.group({
      customerId: this.formBuilder.control(0),
      personId: this.formBuilder.control(0),
      firstName: this.formBuilder.control('', [Validators.required]),
      middleInitial: this.formBuilder.control(''),
      lastName: this.formBuilder.control('', [Validators.required]),
      addressId: this.formBuilder.control(''),
      addressStreet: this.formBuilder.control('', Validators.required),
      addressStreet2: this.formBuilder.control(''),
      addressCity: this.formBuilder.control('', Validators.required),
      addressStateId: this.formBuilder.control('', Validators.required),
      stateAbbrv: this.formBuilder.control(''),
      country: this.formBuilder.control(''),
      addressPostalCode: this.formBuilder.control('', Validators.required),
      countryId: this.formBuilder.control('', Validators.required),
      workPhone: this.formBuilder.control('', [Validators.pattern(/^\(\d{3}\)\s\d{3}-\d{4}$/)]),
      otherPhone: this.formBuilder.control('', [Validators.required, Validators.pattern(/^\(\d{3}\)\s\d{3}-\d{4}$/)])
    })
  }

  allPhoneValidate() {
    const cellPhoneControl: AbstractControl = this.customerForm.controls['otherPhone'];
    cellPhoneControl.valueChanges.subscribe(data => {
      var newVal1 = this.phoneValidate(data);
      this.customerForm.controls['otherPhone'].setValue(newVal1, { emitEvent: false });
    });
    const workPhoneControl: AbstractControl = this.customerForm.controls['workPhone'];
    workPhoneControl.valueChanges.subscribe(data => {
      var newVal2 = this.phoneValidate(data);
      this.customerForm.controls['workPhone'].setValue(newVal2, { emitEvent: false });
    });
  }
  
   phoneValidate(data: any) {
    let preInputValue:string = this.customerForm.value.otherPhone;
    let lastChar:string = preInputValue.substring(preInputValue.length - 1);
  
    var newVal = data.replace(/\D/g, '');
    if (data.length < preInputValue.length) {
  
      if(lastChar == ')'){
         newVal = newVal.substring(0,newVal.length-1); 
      }
      if (newVal.length == 0) {
        newVal = '';
      } 
      else if (newVal.length <= 3) {
        newVal = newVal.replace(/^(\d{0,3})/, '($1');
      } else if (newVal.length <= 6) {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2');
      } else {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(.*)/, '($1) $2-$3');
      }
    } else{   
  
    if (newVal.length == 0) {
      newVal = '';
    } 
    else if (newVal.length <= 3) {
      newVal = newVal.replace(/^(\d{0,3})/, '($1)');
    } else if (newVal.length <= 6) {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2');
    } else {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(.*)/, '($1) $2-$3');
    }
  }
  return newVal;
  }


  onStateSelect($event: any) {
    //TODO: set the country id based on the state selected (do the same for on country select)
  }

  submitChange() {
    if (this.customerForm.valid) {

      this._customerService.saveCustomerProfile$(this.customerForm!.value).subscribe(response => {
        if (!!response) {
          this.toastService.success('Saved successfully.');
          this.showEditForm = false;
        }
        else {
          this.submitted = false;
          this.toastService.error('An error has occurred. User data not saved.');  //TODO: Return specific error from api
        }
      });
    } else {
      this.showEditForm = true;
    }
  }

  cancelChange() {
    if (this.customerForm.dirty) {
      this.customer = this._customerService.getCustomerProfile$(this.custId!).pipe(tap((cust: { [key: string]: any; }) => this.customerForm.patchValue(cust)));
    }
    this.showEditForm = false;
  }

}
